import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';

import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  PersonPinCircle as PersonCircleIcon,
  Warning as WarningIcon,
} from '@mui/icons-material/';

function ModalUserNeedManualCheck() {
  const { t } = useTranslation();

  const inputRef = useRef(null);

  const {
    session,
    updateFocusOnMainScreen,
    updateShowModalUserNeedManualCheck,
    logoutUser,
    userInfo,
    parentInfo,

    updateShowModalConfirmIdentity,
    updateIsNeedConfirmation,
    updateShowModalPictureVerificationWarning,
    updateIsPictureVerificationNeeded,
    updateIsVerificationNeeded,
    updateShowModalIsVerificationNeeded,
  } = useContext(AppContext);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);

  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  // #region //* DISABLE FOCUS ON MAIN SCREEN AND PREVENT ESCAPE BUTTON
  useEffect(() => {
    updateFocusOnMainScreen(false);

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 900);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleConfirm = () => {
    updateFocusOnMainScreen(true);
    //logoutUser();
    updateShowModalUserNeedManualCheck(false);

    if (
      (parentInfoRef.current &&
        (!parentInfoRef.current['Verification method'] ||
          !parentInfoRef.current['SSN ID'])) ||
      (!parentInfoRef.current &&
        (!userInfoRef.current['Verification method'] ||
          !userInfoRef.current['SSN ID']) &&
        !userInfoRef.current.username.startsWith('anon') &&
        !userInfoRef.current.username.startsWith('hybrid'))
    ) {
      updateIsVerificationNeeded(true);
      updateShowModalIsVerificationNeeded(true);
      return;
    }

    //* IMAGE VERIFICATION
    if (
      (parentInfoRef.current &&
        !parentInfoRef.current['Verification image ID'] &&
        !parentInfoRef.current['Disabled login reason']) ||
      (!parentInfoRef.current &&
        !userInfoRef.current['Verification image ID'] &&
        !userInfoRef.current.username.startsWith('anon') &&
        !userInfoRef.current['Disabled login reason'])
    ) {
      updateIsPictureVerificationNeeded(true);
      if (
        userInfoRef.current &&
        !parentInfoRef.current &&
        userInfoRef.current.username.startsWith('hybrid')
      ) {
        updateShowModalPictureVerificationWarning(false);
        return;
      }
      if (
        parentInfoRef.current &&
        parentInfoRef.current.username.startsWith('hybrid')
      ) {
        updateShowModalPictureVerificationWarning(false);
        return;
      }
      updateShowModalPictureVerificationWarning(true);
      updateIsNeedConfirmation(true);
      return;
    }

    updateShowModalConfirmIdentity(true);
  };

  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <>
              <h1>{t('sales.userIsNotAllowed')}</h1>
              <p>
                {' '}
                {t('sales.reason')} {t('sales.waitingForApprovalText')}
              </p>
              <p>
                <strong>{t('sales.salesDisabled')}</strong>
              </p>

              <div className="react-confirm-alert-button-group">
                <button
                  className="btn-custom-yes "
                  onClick={() => {
                    handleConfirm();
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px', // Space between icon and text
                  }}
                >
                  <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                  {t('sales.confirm')}
                </button>
              </div>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalUserNeedManualCheck;
